// extracted by mini-css-extract-plugin
export default {"fullWidth":"xI-z","image":"yI-z","lazyLoadPicture":"zI-z","lazyLoadSpinner":"AI-z","lazyLoadSpin":"BI-z","lazyLoadImage":"CI-z","hasStyledAspectRatio":"DI-z"};